var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {},
    [
      !_vm.loading && _vm.players
        ? _c(
            "v-card",
            {
              staticClass: "overflow-auto",
              attrs: {
                elevation: "0",
                outlined: "",
                "min-height": "350",
                "max-height": "500",
              },
            },
            [
              _c(
                "v-card-title",
                {
                  staticClass: "py-1 white--text d-flex align-center",
                  class: _vm.$vuetify.theme.dark ? "black" : "primary",
                },
                [
                  _c(
                    "div",
                    { staticClass: "d-flex align-center" },
                    [
                      _c(
                        "v-icon",
                        {
                          staticClass: "mr-2",
                          attrs: { color: "white", medium: "" },
                        },
                        [_vm._v("emoji_flags")]
                      ),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticClass:
                            "white--text body-font body-1 font-weight-bold text-uppercase",
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$vuetify.breakpoint.mdAndUp
                                ? _vm.$t("dashboards.nationalPlayers")
                                : _vm.$t("dashboards.nationalPlayersShort")
                            )
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "pr-3 pb-2 pl-3 pt-3" },
                _vm._l(_vm.players, function (player) {
                  return _c(
                    "div",
                    {
                      key: player.playerId,
                      staticClass: "d-flex flex-column mb-2",
                    },
                    [
                      _c("div", { staticClass: "d-flex align-center" }, [
                        _vm.$vuetify.breakpoint.mdAndUp
                          ? _c("img", {
                              staticClass: "mr-2",
                              attrs: {
                                src: `https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/faces/${player.playerId}.png`,
                                width: "40",
                              },
                              on: {
                                error: function ($event) {
                                  return _vm.onImageLoadFailure($event, player)
                                },
                              },
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "d-flex flex-column flex-grow-1" },
                          [
                            _c(
                              "div",
                              { staticClass: "d-flex align-center" },
                              [
                                _c(
                                  "router-link",
                                  {
                                    staticClass:
                                      "body-2 font-weight-bold text-ellipsis",
                                    class: _vm.$vuetify.theme.dark
                                      ? "primary--text"
                                      : "secondary--text text--darken-2",
                                    attrs: { to: `/player/${player.playerId}` },
                                  },
                                  [_vm._v(_vm._s(player.name))]
                                ),
                                _vm._v(" "),
                                _c(
                                  "router-link",
                                  {
                                    staticClass:
                                      "d-flex align-center body-2 ml-2",
                                    attrs: { to: `/team/${player.teamId}` },
                                  },
                                  [
                                    _c("img", {
                                      staticClass: "mr-1",
                                      attrs: {
                                        src: `https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/${player.teamId}.png`,
                                        width: "15",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("span", [
                                      _vm._v(_vm._s(player.teamName)),
                                    ]),
                                  ]
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "d-flex align-center" },
                              [
                                _vm.$vuetify.breakpoint.mdAndUp
                                  ? _c(
                                      "div",
                                      { staticClass: "d-flex align-center" },
                                      [
                                        _c(
                                          "v-chip",
                                          {
                                            staticClass: "mr-1 monospace-font",
                                            attrs: {
                                              color: _vm.getPositionChip(
                                                _vm.getFieldPositionIdByDefaultCode(
                                                  player.position
                                                )
                                              ),
                                              "text-color": "white",
                                              "x-small": "",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.getPositionCode(
                                                  _vm.getFieldPositionIdByDefaultCode(
                                                    player.position
                                                  )
                                                )
                                              )
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        player.secondPosition
                                          ? _c(
                                              "v-chip",
                                              {
                                                staticClass: "monospace-font",
                                                attrs: {
                                                  color: _vm.getPositionChip(
                                                    _vm.getFieldPositionIdByDefaultCode(
                                                      player.secondPosition
                                                    )
                                                  ),
                                                  "text-color": "white",
                                                  "x-small": "",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.getPositionCode(
                                                      _vm.getFieldPositionIdByDefaultCode(
                                                        player.secondPosition
                                                      )
                                                    )
                                                  )
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.$vuetify.breakpoint.mdAndUp
                                  ? _c("v-divider", {
                                      staticClass: "mx-1",
                                      attrs: { vertical: "" },
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.$vuetify.breakpoint.mdAndUp
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "d-flex align-center mx-1",
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "primary--text font-weight-bold body-2",
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.currentUserCurrencySymbol
                                              )
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "ml-1 primary--text font-weight-bold body-2",
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("formatCash")(
                                                  player.marketValue
                                                    ? player.marketValue * 1000
                                                    : "-",
                                                  _vm.currentUserRate
                                                )
                                              )
                                            ),
                                          ]
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.$vuetify.breakpoint.mdAndUp
                                  ? _c("v-divider", {
                                      staticClass: "mx-1",
                                      attrs: { vertical: "" },
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.$vuetify.breakpoint.mdAndUp
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "d-flex align-center ml-1",
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "primary--text font-weight-bold body-2",
                                          },
                                          [_vm._v(_vm._s(player.age))]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "ml-1 primary--text body-2",
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("playerDetail.yearsOld")
                                              )
                                            ),
                                          ]
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _c("v-divider"),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "d-flex lightSecondary lighten-4 py-1 px-2 rounded-b",
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "w-50 d-flex flex-column" },
                            [
                              _c(
                                "span",
                                { staticClass: "subheader-font body-2" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("charts.currentSeasonSelectText")
                                    )
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("span", { staticClass: "body-2" }, [
                                _vm._v(_vm._s(player.seasonTeamName)),
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "d-flex body-2" },
                                [
                                  _c("div", { staticClass: "w-50" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "d-flex align-center justify-space-between",
                                      },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "subheader-font" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "playerDetail.playerUsage"
                                                )
                                              )
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(player.seasonMinsPlayed)
                                          ),
                                        ]),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "d-flex align-center justify-space-between",
                                      },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "subheader-font" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("playerScout.goals")
                                              )
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("span", [
                                          _vm._v(_vm._s(player.seasonGoals)),
                                        ]),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "d-flex align-center justify-space-between",
                                      },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "subheader-font" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("playerScout.assists")
                                              )
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("span", [
                                          _vm._v(_vm._s(player.seasonAssists)),
                                        ]),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "d-flex align-center justify-space-between",
                                      },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "subheader-font" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "playerScout.expectedThreat"
                                                )
                                              )
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              player.seasonXT
                                                ? player.seasonXT.toFixed(2)
                                                : 0
                                            )
                                          ),
                                        ]),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "d-flex align-center justify-space-between",
                                      },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "subheader-font" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "playerScout.yellowCards"
                                                )
                                              )
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(player.seasonYellowCards)
                                          ),
                                        ]),
                                      ]
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _vm.$vuetify.breakpoint.mdAndUp
                                    ? _c("v-divider", {
                                        staticClass: "mx-1",
                                        attrs: { vertical: "" },
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "w-50" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "d-flex align-center justify-space-between",
                                      },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "subheader-font" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("table.history.games")
                                              )
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("span", [
                                          _vm._v(_vm._s(player.gamesPlayed)),
                                        ]),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "d-flex align-center justify-space-between",
                                      },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "subheader-font" },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.$t("playerScout.xG"))
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              player.seasonXG
                                                ? player.seasonXG.toFixed(2)
                                                : 0
                                            )
                                          ),
                                        ]),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "d-flex align-center justify-space-between",
                                      },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "subheader-font" },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.$t("playerScout.xA"))
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              player.seasonXA
                                                ? player.seasonXA.toFixed(2)
                                                : 0
                                            )
                                          ),
                                        ]),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "d-flex align-center justify-space-between",
                                      },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "subheader-font" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("statsNaming.xTOpenPlay")
                                              )
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              player.seasonXTOpenPlay
                                                ? player.seasonXTOpenPlay.toFixed(
                                                    2
                                                  )
                                                : 0
                                            )
                                          ),
                                        ]),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "d-flex align-center justify-space-between",
                                      },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "subheader-font" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("playerScout.redCards")
                                              )
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("span", [
                                          _vm._v(_vm._s(player.seasonRedCards)),
                                        ]),
                                      ]
                                    ),
                                  ]),
                                ],
                                1
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c("v-divider", {
                            staticClass: "mx-1",
                            attrs: { vertical: "" },
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "w-50 d-flex flex-column" },
                            [
                              _c(
                                "span",
                                { staticClass: "subheader-font body-2" },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("dashboards.lastGameSimple"))
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "d-flex align-center body-2" },
                                [
                                  _c(
                                    "router-link",
                                    {
                                      staticClass: "w-41 d-flex align-center",
                                      attrs: {
                                        to: `/team/${player.homeTeamId}`,
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        [
                                          _c("v-img", {
                                            staticClass: "mx-1",
                                            attrs: {
                                              src: player.homeTeamImgError
                                                ? "https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/0.png"
                                                : "https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/" +
                                                  player.homeTeamId +
                                                  ".png",
                                              height: 18,
                                              width: 18,
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c("span", [
                                        _vm._v(_vm._s(player.homeTeamName)),
                                      ]),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "text-center subheader-font w-15",
                                    },
                                    [
                                      _c("span", { staticClass: "ml-1" }, [
                                        _vm._v(_vm._s(player.homeTeamScore)),
                                      ]),
                                      _vm._v(" "),
                                      _c("span", { staticClass: "mx-1" }, [
                                        _vm._v("-"),
                                      ]),
                                      _vm._v(" "),
                                      _c("span", { staticClass: "mr-1" }, [
                                        _vm._v(_vm._s(player.awayTeamScore)),
                                      ]),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "router-link",
                                    {
                                      staticClass:
                                        "w-41 d-flex align-center justify-end",
                                      attrs: {
                                        to: `/team/${player.awayTeamId}`,
                                      },
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(_vm._s(player.awayTeamName)),
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        [
                                          _c("v-img", {
                                            staticClass: "mx-1",
                                            attrs: {
                                              src: player.awayTeamImgError
                                                ? "https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/0.png"
                                                : "https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/" +
                                                  player.awayTeamId +
                                                  ".png",
                                              height: 18,
                                              width: 18,
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "w-10" },
                                    [
                                      _c(
                                        "v-btn",
                                        {
                                          staticClass: "elevation-0",
                                          attrs: {
                                            block: "",
                                            color: "primary",
                                            to: `/game/${player.gameId}`,
                                            "x-small": "",
                                          },
                                        },
                                        [
                                          _c(
                                            "v-icon",
                                            { attrs: { small: "" } },
                                            [_vm._v("chevron_right")]
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "d-flex body-2" },
                                [
                                  _c("div", { staticClass: "w-50" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "d-flex align-center justify-space-between",
                                      },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "subheader-font" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "playerDetail.playerUsage"
                                                )
                                              )
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("span", [
                                          _vm._v(_vm._s(player.minsPlayed)),
                                        ]),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "d-flex align-center justify-space-between",
                                      },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "subheader-font" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("playerScout.goals")
                                              )
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("span", [
                                          _vm._v(_vm._s(player.goals)),
                                        ]),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "d-flex align-center justify-space-between",
                                      },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "subheader-font" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("playerScout.assists")
                                              )
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("span", [
                                          _vm._v(_vm._s(player.assists)),
                                        ]),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "d-flex align-center justify-space-between",
                                      },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "subheader-font" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "playerScout.expectedThreat"
                                                )
                                              )
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              player.xT
                                                ? player.xT.toFixed(2)
                                                : 0
                                            )
                                          ),
                                        ]),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "d-flex align-center justify-space-between",
                                      },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "subheader-font" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "playerScout.yellowCards"
                                                )
                                              )
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              player.minYellowCard
                                                ? 1
                                                : player.minSecondYellowCard
                                                ? 2
                                                : 0
                                            )
                                          ),
                                        ]),
                                      ]
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _vm.$vuetify.breakpoint.mdAndUp
                                    ? _c("v-divider", {
                                        staticClass: "mx-1",
                                        attrs: { vertical: "" },
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "w-50" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "d-flex align-center justify-space-between",
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "primary--text text--lighten-2",
                                          },
                                          [_vm._v("-")]
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "d-flex align-center justify-space-between",
                                      },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "subheader-font" },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.$t("playerScout.xG"))
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              player.xG
                                                ? player.xG.toFixed(2)
                                                : 0
                                            )
                                          ),
                                        ]),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "d-flex align-center justify-space-between",
                                      },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "subheader-font" },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.$t("playerScout.xA"))
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              player.xA
                                                ? player.xA.toFixed(2)
                                                : 0
                                            )
                                          ),
                                        ]),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "d-flex align-center justify-space-between",
                                      },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "subheader-font" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("statsNaming.xTOpenPlay")
                                              )
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              player.xTOpenPlay
                                                ? player.xTOpenPlay.toFixed(2)
                                                : 0
                                            )
                                          ),
                                        ]),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "d-flex align-center justify-space-between",
                                      },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "subheader-font" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("playerScout.redCards")
                                              )
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(player.minRedCard ? 1 : 0)
                                          ),
                                        ]),
                                      ]
                                    ),
                                  ]),
                                ],
                                1
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                }),
                0
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.loading
        ? _c(
            "v-card",
            { staticClass: "d-flex justify-center align-center py-8 px-12" },
            [
              _c("v-progress-circular", {
                attrs: { size: 75, color: "secondary", indeterminate: "" },
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }